import type { MouseEvent } from 'react';
import { NavLink, useMatch } from 'react-router';
import {
	IconDropStroke,
	IconDropYellow,
	IconProfileStroke,
	IconProfileYellow,
	IconStarStroke,
	IconStarYellow,
} from '@/assets/svgs';
import { useAuth, useLoginRequiredModal } from '@/entities/user';
import { NAVIGATION_HEIGHT } from '@/shared/consts';

const Navigation = () => {
	const isStationsRoute = useMatch('/stations/*');
	const { isLoggedIn } = useAuth();
	const openLoginRequiredModal = useLoginRequiredModal();

	const handleProtectedLinkClick = (e: MouseEvent<HTMLAnchorElement>) => {
		if (isLoggedIn) return;

		e.preventDefault();
		openLoginRequiredModal();
	};

	return (
		<nav
			className="box-s z-50 flex shrink-0 items-center justify-around bg-white drop-shadow-[4px_0px_32px_rgba(0,0,0,0.08)]"
			style={{ height: `${NAVIGATION_HEIGHT}px` }}
		>
			<NavLink
				className="flex flex-col items-center justify-center gap-1 text-[#7e7e7e]"
				to="/favorites"
				onClick={handleProtectedLinkClick}
				aria-label="즐겨찾기"
			>
				{({ isActive }) => (
					<>
						{isActive ? <IconStarYellow /> : <IconStarStroke />}
						<span className={`text-xs ${isActive ? 'text-[#FFC342]' : ''}`}>
							즐겨찾기
						</span>
					</>
				)}
			</NavLink>
			<NavLink
				className="flex flex-col items-center justify-center gap-1 text-[#7e7e7e]"
				to="/"
				aria-label="주유소"
			>
				{isStationsRoute ? <IconDropYellow /> : <IconDropStroke />}
				<span className={`text-xs ${isStationsRoute ? 'text-[#FFC342]' : ''}`}>
					주유소
				</span>
			</NavLink>
			<NavLink
				className="flex flex-col items-center justify-center gap-1 text-[#7e7e7e]"
				to="/profile"
				onClick={handleProtectedLinkClick}
				aria-label="프로필"
			>
				{({ isActive }) => (
					<>
						{isActive ? <IconProfileYellow /> : <IconProfileStroke />}
						<span className={`text-xs ${isActive ? 'text-[#FFC342]' : ''}`}>
							프로필
						</span>
					</>
				)}
			</NavLink>
		</nav>
	);
};

export default Navigation;
